import type { Messages } from "../types";

export const tl = {
  "common": {
    "yes": "Oo",
    "no": "Hindi",
    "continue": "Magpatuloy",
    "saving": "Sine-save…",
    "leaveForNow": "Umalis muna",
    "leave": "umalis",
    "submitting": "Isinusumite…",
    "goBack": "Bumalik ka",
    "brand": "UN8",
    "pleaseWait": "Mangyaring maghintay…",
    "phases": {
      "setup": "Pagse-set up",
      "verify": "I-verify",
      "profile": "Propayl",
      "gate": "Pagsala"
    },
    "ellipsis": "…",
    "male": "Lalaki",
    "storageQuota": "Wala nang espasyo ang teleponong ito para sa mga naka-save na sagot. Magbakante ng ilang storage, pagkatapos ay subukang muli.",
    "brandTag": "Eksklusibong Kristiyanong pakikipag-date",
    "charMetaMin": "min {min} character",
    "female": "Babae",
    "storageDisabled": "Hindi ise-save ng browser na ito ang iyong mga sagot. I-off ang private mode, o payagan ang data ng site, pagkatapos ay i-reload.",
    "charMeta": "{len}/{min} min · {current}/{max}"
  },
  "welcome": {
    "liveServer": "· live na server",
    "signedInAs": "Naka-sign in bilang {email}",
    "promise": "Ang aming layunin ay tanggalin mo ang app na ito sa lalong madaling panahon.",
    "sub": "Tinutulungan ng UN8 ang mga seryosong Kristiyanong walang asawa na makahanap ng makakasama sa buhay — pagkatapos ay umalis. Na-verify. Mga halaga-una. Walang katapusang pag-swipe.",
    "migrateNeedGender": "Piliin muna ang Lalaki o Babae sa iyong profile.",
    "keepOnDevice": "Panatilihin ito sa device na ito lamang",
    "begin": "Magsimula",
    "uploadLocalProfile": "I-upload ang aking lokal na profile",
    "accountDeleted": "Na-delete ang account.",
    "deviceOnly": "· ang device na ito lamang",
    "logIn": "Mag-log in",
    "matching": "Pagtutugma",
    "deleteConfirm": "Permanenteng tanggalin ang iyong account, lahat ng mensahe, at lahat ng media (kabilang ang ID at video) mula sa server?",
    "migrateDone": "Na-upload ang text ng profile. Muling i-upload ang ID, video, at mga larawan para masuri sila ng moderation.",
    "migrateOffer": "Ang device na ito ay mayroon pa ring lokal na profile. I-upload ito sa nakabahaging server para makita ka ng ibang mga telepono pagkatapos ng pag-moderate? Walang ina-upload hanggang sa pumili ka.",
    "reviewConsole": "Suriin ang console",
    "continueOnboarding": "Magpatuloy sa onboarding",
    "logOut": "Mag-log out",
    "deleteMyAccount": "Tanggalin ang aking account"
  },
  "faith": {
    "yesTitle": "Ako ay isang Kristiyano",
    "eyebrow": "Pagsala sa pananampalataya",
    "title": "Kristiyano lamang",
    "respectBody": "Ang UN8 ay binuo para sa isang komunidad, at mas gugustuhin naming maging tapat kaysa mag-aksaya ng iyong oras. Gamitin ang Umalis sa ibaba, o Bumalik, kung hindi ito ang iyong tahanan.",
    "text": "Ang UN8 ay isang komunidad ng mga tagasunod ni Jesu-Kristo, para sa mga miyembrong naghahanap ng mapapangasawang may kaparehas na pananampalataya. Hindi maaaring laktawan ang gate na ito.",
    "yesBody": "Sumusunod ako kay Jesucristo at naghahanap ng mapapangasawang kapareha na may ganitong pananampalataya.",
    "noBody": "UN8 ay hindi ang tamang lugar para sa akin — at ayos lang iyon.",
    "noTitle": "Hindi ako Kristiyano",
    "sharedTitle": "Nakabahaging pundasyon",
    "respectTitle": "Nang may paggalang",
    "sharedBody": "Ang pananampalataya ay hindi isang label dito. Ito ang lupa kung saan kayo magkikita.",
    "hintUnset": "I-tap ang “I am a Christian” para magpatuloy, o Umalis / Bumalik kung hindi mo ito tahanan.",
    "hintNotChristian": "Ang UN8 ay para sa mga tagasunod ni Jesucristo. I-tap ang Umalis sa ibaba, o piliin ang opsyong Kristiyano kung ikaw iyon."
  },
  "rules": {
    "title": "Kung paano namin tratuhin ang isa't isa",
    "eyebrow": "Kasunduan sa komunidad",
    "respectful": {
      "description": "Magsalita at kumilos nang may dignidad. Ang bawat tao dito ay ginawa ayon sa larawan ng Diyos.",
      "title": "Maging magalang"
    },
    "noSexualContent": {
      "description": "Walang mga tahasang larawan, mensahe, o kahilingan. Ang kadalisayan ay hindi opsyonal dito.",
      "title": "Walang sekswal na nilalaman"
    },
    "text": "Pagtibayin ang bawat tuntunin. Lahat ng tatlo ay kinakailangan. Ang mga paglabag ay humahantong sa permanenteng pag-alis. Ang mga pekeng profile ay ipinagbabawal magpakailanman.",
    "agreeContinue": "Sumasang-ayon ako - magpatuloy",
    "hint": "Lagyan ng tsek ang tatlong pangako bago ka magpatuloy.",
    "noDominance": {
      "description": "Walang pamimilit, manipulasyon, o panggigipit. Hindi kontrolado ng pag-ibig.",
      "title": "Huwag mangibabaw o kontrolin"
    }
  },
  "intent": {
    "eyebrow": "",
    "title": "Ano ang hinahanap mo?",
    "text": "",
    "marriage": {
      "label": "Kasama sa buhay",
      "description": ""
    },
    "discernment": {
      "label": "Seryosong pagkilala",
      "description": ""
    },
    "notCasual": {
      "label": "Walang casual",
      "description": ""
    },
    "hint": "Pumili ng isa."
  },
  "account": {
    "title": "Lumikha ng iyong access",
    "recoveryTitle": "I-save ang iyong code sa pagbawi",
    "eyebrow": "Iyong account",
    "handle": "Panghawakan",
    "handlePlaceholder": "you@example.com o isang maikling hawakan",
    "savedContinue": "Nai-save ko na ito — magpatuloy",
    "text": "Lumilikha ang iyong handle ng isang matatag na user id. Ang aplikasyon, pag-verify, pag-like, at tugma ay lahat ay nakatali sa id na iyon. Walang email na ipinadala.",
    "continueToVerification": "Magpatuloy sa pag-verify",
    "passphrase": "Lihim na parirala",
    "passphrasePlaceholder": "Hindi bababa sa 8 character",
    "trustTitle": "Pamantayan ng tiwala",
    "trustBody": "Walang makikitang profile hanggang sa makumpleto ang pag-verify ng pagkakakilanlan at aprubahan ka ng moderation.",
    "signedInTitle": "Naka-sign in",
    "recoveryText": "Ipinakita ng isang beses. Kung wala ito, hindi mai-reset ang nawalang passphrase sa closed test na ito.",
    "signedInBody": "{email} · {userId}",
    "hintPassword": "Pumili ng password na hindi bababa sa 8 character.",
    "hintEmail": "Mag-type ng email address na may kasamang @."
  },
  "verify": {
    "intro": {
      "text": "Mag-upload ng government ID, isang video ng kumpirmasyon, at {min}–{max} totoong larawan. Ang lahat ay pumapasok sa isang queue ng pagsusuri bago lumitaw ang iyong profile.",
      "whyBody": "Ang catfishing at half-truths ay walang lugar dito. Ang mga pekeng profile ay permanenteng pinagbawalan. Iniimbak ang media na may katayuang pending_review hanggang maaprubahan.",
      "title": "Ang tiwala ay ang pintuan",
      "whyTitle": "Bakit namin i-verify",
      "start": "Simulan ang pag-verify",
      "eyebrow": "Pagpapatunay"
    },
    "steps": {
      "video": {
        "description": "Isang maikling recording na nagpapatunay na naroroon ka.",
        "title": "Video ng kumpirmasyon"
      },
      "photos": {
        "description": "Pito hanggang sampung malinaw na larawan ng iyong sarili.",
        "title": "Mga totoong larawan"
      },
      "review": {
        "title": "Pagsusuri ng integridad",
        "description": "Ang mga pag-upload ay mananatiling pending_review hanggang kumpirmahin ng staff."
      },
      "id": {
        "title": "ID ng gobyerno",
        "description": "Pasaporte o pambansang ID — pag-upload ng camera o file."
      }
    },
    "id": {
      "title": "ID ng gobyerno",
      "savedTitle": "Na-save ang ID",
      "eyebrow": "Hakbang 1 ng 4",
      "hint": "Kumuha o mag-upload ng larawan ng iyong government ID, pagkatapos ay maghintay hanggang sa sabihin nito na naka-save.",
      "text": "Kunin o i-upload ang iyong pasaporte o pambansang ID. Walang naka-post sa publiko — mananatili ang status pending_review hanggang kumpirmahin ng staff.",
      "savedBody": "Susunod ay isang maikling kumpirmasyon na video ng iyong mukha, pagkatapos ay 7 hanggang 10 totoong larawan ng iyong sarili. Magpatuloy sa pag-unlock kapag nakitang naka-save ang ID na ito."
    },
    "video": {
      "title": "Video ng kumpirmasyon",
      "eyebrow": "Hakbang 2 ng 4",
      "hint": "Mag-record ng maikling video ng kumpirmasyon, pagkatapos ay maghintay hanggang sa sinabi nitong naka-save.",
      "text": "Mag-record ng maikling clip o mag-upload ng isa. Harapin ang camera. Magsalita ng malinaw. Ito ay nagpapatunay na ikaw ay naroroon — hindi isang nasimot na gallery."
    },
    "photos": {
      "title": "Mga totoong larawan",
      "eyebrow": "Hakbang 3 ng 4",
      "continueToReview": "Ipagpatuloy ang pagsusuri",
      "text": "Magdagdag ng {min}–10 kamakailang larawan ng iyong sarili. Gamitin ang camera o ang iyong library. I-tap ang × upang alisin ang anumang shot.",
      "hint": "Magdagdag ng {min} sa 10 malinaw na larawan ng iyong sarili. Magpatuloy sa pag-unlock kapag na-save ang mga ito."
    },
    "review": {
      "title": "Pagsusuri ng integridad",
      "governmentId": "ID ng gobyerno",
      "confirmationVideo": "Video ng kumpirmasyon",
      "photos": "Mga larawan",
      "underUser": "sa ilalim ng user {userId}",
      "eyebrow": "Hakbang 4 ng 4",
      "missing": "Nawawala",
      "text": "Nakapila ang media bilang pending_review{underUser}. Ang mga tugma at gusto ay gagamit ng parehong id.",
      "submittedText": "Ang application id ay katumbas ng auth user id kaya aprubahan → pool at mutual likes manatiling nakahanay.",
      "submittedTitle": "Naisumite para sa pagsusuri",
      "filesReady": "{count} file ang handa na",
      "submitContinue": "Isumite at magpatuloy"
    }
  },
  "setup": {
    "title": "Sabihin ang totoo tungkol sa iyong sarili",
    "text": "Ang mga sagot na ito ay tugma sa hugis at lumilitaw sa pagsusuri. Ang malalambot na kasinungalingan ay nag-aaksaya ng oras ng lahat — kasama na ang sa iyo.",
    "beginSetup": "Simulan ang pag-setup",
    "eyebrow": "Pag-setup ng account",
    "pillars": {
      "life": {
        "name": "Buhay",
        "text": "Mga libangan, pagbabasa, at bokasyon."
      },
      "faith": {
        "text": "Bakit ka sumusunod kay Kristo.",
        "name": "Pananampalataya"
      },
      "character": {
        "name": "karakter",
        "text": "Katapatan, katapatan, simbuyo ng damdamin, pangako — rated 1–10."
      },
      "story": {
        "name": "Kwento",
        "text": "Sino ka at ano ang hinahanap mo."
      }
    },
    "whyChristian": {
      "eyebrow": "Pananampalataya",
      "placeholder": "hal. Nakilala ko si Kristo sa panahon ng pagkawala at sinundan ko Siya mula noon...",
      "hint": "Sumulat ng hindi bababa sa {min} na mga karakter tungkol sa kung bakit mo sinusunod si Jesus.",
      "title": "Bakit ka Kristiyano?",
      "label": "Ang sagot mo",
      "text": "Isang maikli, tapat na sagot. Hindi sermon — isang dahilan na sa iyo."
    }
  },
  "scales": {
    "title": "I-rate ang iyong sarili nang tapat",
    "eyebrow": "Mga kaliskis ng karakter",
    "loyalty": {
      "label": "Antas ng katapatan",
      "hint": "Maging tapat — gaano ka katapat na pinaninindigan ang mga mahal mo?"
    },
    "passion": {
      "hint": "Conviction at depth — hindi performance.",
      "label": "Gaano ka ka-passionate?"
    },
    "honesty": {
      "hint": "Gaano ka palagiang sinasabi ang buong katotohanan?",
      "label": "Antas ng katapatan"
    },
    "hint": "Ilipat ang bawat slider para lumabas ang isang numero — walang maaaring manatili bilang isang gitling.",
    "text": "Loyalty, honesty, passion, commitment — bawat isa mula 1 hanggang 10. Ang pagpapalaki ng mga numero ay hindi tumutugma sa iyo sa ibang pagkakataon. Dapat mong itakda ang bawat sukat upang magpatuloy.",
    "commitment": {
      "label": "Antas ng pangako",
      "hint": "Gaano ka handa na bumuo ng isang bagay na tumatagal?"
    }
  },
  "about": {
    "eyebrow": "Tungkol sayo",
    "label": "Tungkol sayo",
    "text": "Sino ka kapag walang nagpe-perform. Temperament, ritmo, kung ano ang mahalaga araw-araw.",
    "title": "Ilarawan ang iyong sarili sa ilang mga pangungusap",
    "hint": "Sumulat ng hindi bababa sa {min} character tungkol sa iyong sarili.",
    "placeholder": "Tahimik na umaga, seryoso sa pamilya, madaling tumawa, mas gusto ang lalim kaysa ingay..."
  },
  "looking": {
    "eyebrow": "Kasosyo",
    "title": "Ano ang hinahanap mo?",
    "label": "Ninanais na mga katangian ng karakter",
    "hint": "Sumulat ng hindi bababa sa {min} na mga character tungkol sa kapareha na inaasahan mo.",
    "placeholder": "hal. Matatag na pananampalataya, emosyonal na kapanahunan, kabaitan sa ilalim ng stress...",
    "text": "Mga pangunahing katangian ng karakter na gusto mo sa isang potensyal na kasosyo — hindi isang listahan ng pamimili ng mga hitsura."
  },
  "loveReady": {
    "eyebrow": "Huling tanong",
    "yesTitle": "Oo - handa na ako",
    "comeBackTitle": "Bumalik ka kapag handa na",
    "noTitle": "Hindi pa",
    "text": "Umiiral ang UN8 kaya ang mga seryosong single ay nakahanap ng kapareha — pagkatapos ay tanggalin ang app. Tanging ang \"Oo\" na pag-unlock ang nagpapatuloy.",
    "title": "Handa ka na bang makilala ang mahal mo sa buhay?",
    "noBody": "Kung nagba-browse ka lang, hindi angkop ang komunidad na ito.",
    "hintUnset": "I-tap ang Oo kung handa ka nang makilala ang isang tao para sa kasal.",
    "comeBackBody": "Ang UN8 ay para sa mga taong handang makipagkita — hindi para mangolekta ng mga opsyon. Gamitin ang Umalis sa ibaba kung gusto mong huminto sa ngayon. Ang iyong mga sagot ay naka-save sa teleponong ito.",
    "yesBody": "Narito ako upang makilala ang aking tao nang may kalinawan at lakas ng loob.",
    "hintNo": "\"Oo\" lang ang nagpapatuloy. Kung hindi ka pa handa, i-tap ang Umalis sa ngayon — mananatili ang iyong mga sagot sa teleponong ito."
  },
  "lifestyle": {
    "eyebrow": "Pamumuhay",
    "profession": "Propesyon / sektor",
    "title": "Paano ka namumuhay araw-araw",
    "reading": "nagbabasa ka ba?",
    "hobbies": "Kasalukuyang palakasan o libangan",
    "readingHint": "1 = halos hindi kailanman · 10 = araw-araw, malalim na pagbabasa",
    "text": "Palakasan, libangan, pagbabasa, at propesyon — mga praktikal na senyales para sa tunay na pagkakatugma.",
    "hobbiesPlaceholder": "Ang aktibong ginagawa mo — hindi ang dati mong ginagawa.",
    "hintHobbies": "Pangalan ng kahit isang sport o libangan na talagang ginagawa mo.",
    "hintProfession": "I-type ang gawaing ginagawa mo, kahit isang maikling salita.",
    "professionPlaceholder": "hal. Nursing · Software · Edukasyon · Trades",
    "hintReading": "Slide \"Nabasa mo ba?\" kaya isang numero mula 1 hanggang 10 ay nagpapakita."
  },
  "faithDepth": {
    "eyebrow": "Pagtutugma · Pananampalataya",
    "title": "Gaano kasentro ang iyong pananampalataya?",
    "text": "Paglilingkod sa Diyos — gaano kahalaga sa iyong buhay? Sagot ng tapat. Ginagamit ito ng pagtutugma para sa lalim, hindi sa pagganap.",
    "serving": "Paglilingkod sa Diyos — kahalagahan",
    "seldom": {
      "label": "Bihira",
      "hint": "Paminsan-minsan, hindi isang lingguhang ritmo."
    },
    "churchAttendance": "pagdalo sa simbahan",
    "frequent": {
      "label": "Madalas",
      "hint": "Regular na pagtitipon kasama ang katawan ni Kristo."
    },
    "servingHint": "10% … 100%. Mag-slide sa mga hakbang ng 10.",
    "keepsCommandments": "Sinusunod mo ba ang mga utos?",
    "grewUpInChurch": "Lumaki ka ba sa simbahan?",
    "never": {
      "label": "Hindi kailanman",
      "hint": "Kasalukuyang hindi pumapasok."
    },
    "hasIdols": "May mga idol ka ba?",
    "hintAttendance": "Piliin kung gaano kadalas ka nagsisimba.",
    "spreadsGospel": "Ipinakalat mo ba ang ebanghelyo?",
    "hintServing": "Slide kung gaano kahalaga ang paglilingkod sa Diyos sa iyong buhay.",
    "hintGospel": "Sagutin kung ibinabahagi mo ang ebanghelyo — Oo o Hindi.",
    "hintGrewUp": "Sagutin kung lumaki ka sa simbahan — Oo o Hindi.",
    "hintCommandments": "Sagutin kung sinusunod mo ang mga utos — Oo o Hindi.",
    "hintIdols": "Sagutin kung mayroon kang mga idolo — Oo o Hindi."
  },
  "character": {
    "title": "Sino ka sa bahay",
    "caring": "Mapagmalasakit at mapagmahal?",
    "homebuilder": "Ikaw ba ay isang homebuilder?",
    "humorous": "Nakakatawa ka ba?",
    "peacemaker": "Ikaw ba ay isang tagapamayapa?",
    "eyebrow": "Pagtutugma · Tauhan",
    "text": "Character para sa panliligaw — peacemaking, manners, honesty. Ang pagpapalaki ng mga sagot ay hindi tumutugma sa iyo sa ibang pagkakataon.",
    "peacefulHome": "Gusto mo ba ng mapayapang tahanan — walang away?",
    "honestyRating": "Honesty rating sa questionnaire na ito",
    "hintHumorous": "Sagutin mo kung nakakatawa ka.",
    "hintHomebuilder": "Sagutin kung ikaw ay isang homebuilder.",
    "hintPeacemaker": "Sagutin ang bawat Oo o Hindi, simula sa tagapamayapa.",
    "honestyHint": "1–10 — gaano ka katapat ang pagsagot?",
    "manners": "Magandang asal?",
    "hintHonesty": "I-slide ang iyong honesty rating mula 1 hanggang 10.",
    "hintCaring": "Sagutin kung ikaw ay nagmamalasakit at mapagmahal.",
    "hintPeaceful": "Sagutin kung gusto mo ng mapayapang tahanan.",
    "hintManners": "Sagutin mo kung maganda ang ugali mo."
  },
  "history": {
    "eyebrow": "Pagtutugma · Kasaysayan",
    "title": "Nakaraan at kahandaan",
    "otherDrugs": "Gumamit ka na ba ng ibang gamot?",
    "text": "Mga sangkap, pagkabata, peklat, at kung handa ka na para sa isang pangmatagalang relasyon. Ang katotohanan dito ay nagpoprotekta sa inyong dalawa.",
    "scars": "May peklat/nasira?",
    "marijuana": "Gumamit ka na ba ng marijuana?",
    "lsd": "Gumamit ka na ba ng LSD?",
    "addicted": "Naadik ka na ba?",
    "hintScars": "Sagutin kung may mga galos ka.",
    "hintAddicted": "Sagutin mo kung naadik ka na.",
    "hintOtherDrugs": "Sagutin kung gumamit ka ng ibang gamot.",
    "childhood": "Matatag, mapagmahal na pagkabata?",
    "hintLsd": "Sagutin ang tanong ng LSD — Oo o Hindi.",
    "lasting": "Handa ka na ba sa isang pangmatagalang relasyon?",
    "hintStart": "Sagutin ang bawat Oo o Hindi sa pahinang ito, simula sa itaas.",
    "hintChildhood": "Sagutin kung ang iyong pagkabata ay matatag at mapagmahal.",
    "hintLasting": "Sagutin kung handa ka na para sa isang pangmatagalang relasyon."
  },
  "appearance": {
    "eyebrow": "Pagtutugma · Hitsura",
    "title": "Mga tattoo",
    "hasTattoos": "May tattoo ka ba?",
    "text": "Ang iyong mga tattoo, at kung ang mga tattoo sa isang kapareha ay katanggap-tanggap sa iyo.",
    "hintAccepts": "Sabihin kung ang mga tattoo sa isang kapareha ay katanggap-tanggap sa iyo.",
    "hintHas": "Sabihin kung mayroon kang mga tattoo — Oo o Hindi.",
    "acceptsPartner": "Tanggapin ang mga tattoo sa isang kapareha?"
  },
  "home": {
    "text": "Mga halamang-gamot, lumalagong pagkain, kagubatan ng prutas, paghahanda, pagsasaka sa komunidad, pag-iingat, kaligtasan ng buhay — at anumang espesyal na kasanayan.",
    "title": "Lupain, kasanayan, sariling kakayahan",
    "eyebrow": "Tugma · Tahanan at lupa",
    "canning": "Canning at pag-iingat?",
    "survival": "Mga kasanayan sa kaligtasan?",
    "herbKnowledge": "Kaalaman sa damo?",
    "prepping": "Naghahanda para sa mga kalamidad?",
    "communityFarming": "Pagsasaka sa komunidad / malayang pamumuhay?",
    "specialSkills": "Mga espesyal na kasanayan (opsyonal)",
    "fruitForest": "Interesado sa isang kagubatan ng prutas?",
    "plantOwn": "Nagtatanim ka ba ng sarili mong prutas at gulay?",
    "specialPlaceholder": "Anumang bagay na dadalhin mo sa isang sambahayan o lupa...",
    "hintStart": "Sagutin ang bawat Oo o Hindi sa lupa at kasanayan, simula sa itaas.",
    "hintPlant": "Sagutin kung nagtatanim ka ng sarili mong prutas at gulay.",
    "hintPrepping": "Sagutin kung naghahanda ka para sa mga kalamidad.",
    "hintCanning": "Sagutin kung kaya mo at mag-imbak ng pagkain.",
    "hintSurvival": "Sagutin kung mayroon kang mga kasanayan sa kaligtasan.",
    "hintCommunity": "Sagutin kung interesado ka sa pagsasaka ng komunidad.",
    "hintFruitForest": "Sagutin kung interesado ka sa isang fruit forest."
  },
  "family": {
    "children": "Mga bata",
    "open": {
      "label": "Bukas",
      "hint": "Maunawain — hindi naka-lock sa alinmang paraan."
    },
    "text": "Ano ang kailangan mo sa isang kapareha sa intensity ng pananampalataya, mga bata, at nakaraang paggamit ng substance.",
    "eyebrow": "Pagtutugma · Pamilya",
    "doesNotWant": {
      "label": "Ayaw ng mga bata",
      "hint": "Clear no sa mga bata."
    },
    "wants": {
      "label": "Gusto ng mga bata",
      "hint": "Ang pagbuo ng isang pamilya ay bahagi ng pangitain."
    },
    "title": "Mga bata, lalim ng pananampalataya, mga sangkap",
    "acceptsSubstances": "Tanggapin ang nakaraang paggamit ng substance sa isang partner?",
    "requiredFaithHint": "10% … 100%. Matigas na gate kapag sinagot na ng magkabilang panig.",
    "requiredFaith": "Pinakamababang antas ng pananampalataya na kailangan mo sa isang kapareha",
    "hasLivingWith": {
      "label": "May mga anak — nakatira kasama nila",
      "hint": "Ang mga bata ay bahagi na ng pang-araw-araw na buhay."
    },
    "hintChildren": "Pumili ng isang card tungkol sa mga bata.",
    "hintSubstances": "Sabihin kung ang nakaraang paggamit ng substance sa isang kapareha ay katanggap-tanggap.",
    "hintFaith": "I-slide ang pinakamababang antas ng pananampalataya na inaasahan mo sa isang kapareha."
  },
  "ancestry": {
    "text": "Ibahagi ang iyong background at kung ano ang iyong bukas sa isang partner. Ito ay humuhubog lamang sa pagraranggo — hindi nito itinatago ang isang tao mula sa deck.",
    "openToPartner": "Bukas sa isang kasosyo",
    "eyebrow": "Pagtutugma · Background",
    "title": "Mga kagustuhan sa background",
    "codeDesc": "Kodigo: {code}",
    "yourBackground": "Ang iyong background (piliin ang lahat ng naaangkop)",
    "preferenceOnly": "Preference lang — hindi gate.",
    "anyDesc": "Pinakamalakas na kagustuhan para sa lawak — inirerekomenda kapag hindi sigurado.",
    "hintAccepted": "Lagyan ng tsek kung ano ang iyong bukas sa isang kasosyo, o “Buksan — walang kagustuhan”.",
    "hintOwn": "Lagyan ng tsek ang kahit isang background na naglalarawan sa iyo. Nakakatulong lang ito sa pagraranggo — hindi nito itinatago ang sinuman."
  },
  "interests": {
    "hint": "Lagyan ng tsek ang hindi bababa sa isang interes.",
    "title": "Ang tinatamasa mo",
    "text": "Pumili ng kahit isa. Nakakatulong ang overlap sa pagraranggo; ang katahimikan ay hindi kailanman pinarurusahan.",
    "eyebrow": "Pagtutugma · Mga Interes"
  },
  "reflection": {
    "title": "Sa sarili mong salita",
    "eyebrow": "Pagtutugma · Pagninilay",
    "describeYourself": "Ilarawan ang iyong sarili",
    "fifteenYear": "Ikaw at ang pag-ibig ng iyong buhay sa loob ng 15 taon",
    "hintPurpose": "Isulat ang layunin ng iyong buhay sa hindi bababa sa {min} na mga character.",
    "hintWeaknesses": "Pangalanan ang isang kahinaan sa hindi bababa sa {min} character.",
    "hintDescribe": "Ilarawan ang iyong sarili sa hindi bababa sa {min} na mga character.",
    "hintVision": "Isulat ang 15-taong pangitain sa hindi bababa sa {min} na mga character.",
    "text": "Ang apat na sagot na ito ay ipinapakita nang buo at hindi kailanman nai-score. Isulat kung ano ang totoo.",
    "lifePurpose": "Layunin ng buhay",
    "weaknesses": "Mga kahinaan"
  },
  "profile": {
    "eyebrow": "Propayl",
    "age": "Edad",
    "city": "lungsod",
    "cityPlaceholder": "Kung saan ka nakabase",
    "title": "Ilang mahahalagang bagay",
    "sex": "kasarian",
    "agePlaceholder": "18+",
    "firstName": "Pangalan",
    "firstNamePlaceholder": "Tulad ng nais mong makilala",
    "maleBody": "lalaki ako.",
    "text": "Panatilihin itong simple. Binary dito ang sex — lalaki o babae — para sa malinaw na pagtutugma.",
    "femaleBody": "Babae ako.",
    "hintAge": "Ang edad ay dapat na 18 o mas matanda.",
    "hintName": "I-type ang iyong pangalan (hindi bababa sa dalawang titik).",
    "hintCity": "I-type ang lungsod kung saan ka nakatira.",
    "hintGender": "Pumili ng Lalaki o Babae para gumana ang pagtutugma."
  },
  "ready": {
    "title": "Maaari kang pumasok.",
    "textNamed": "{name}, ang iyong pag-verify at setup ay naitala. Ang media ay pending_review. Maligayang pagdating sa UN8 — hanapin ang iyong tao, pagkatapos ay tanggalin ang app.",
    "text": "Ang iyong pag-verify at pag-setup ay naitala. Ang media ay pending_review. Maligayang pagdating sa UN8 — hanapin ang iyong tao, pagkatapos ay tanggalin ang app.",
    "genderProfession": "{gender} · {profession}",
    "professionFallback": "propesyon",
    "summaryAria": "Buod ng pag-setup",
    "enterMatching": "Ipasok ang pagtutugma",
    "userLine": "Gumagamit {userId}",
    "sexUnset": "Kasarian —",
    "christianRules": "Kristiyano · pinagtibay ang mga tuntunin",
    "scalesLine": "Mga kaliskis L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "mediaLine": "ID · video · {photoCount} larawan · pila {pending}",
    "needGender": "Bumalik sa hakbang sa profile at piliin ang Lalaki o Babae, pagkatapos ay subukang muli."
  },
  "match": {
    "brandTag": "Pagtutugma",
    "navReview": "Balik-aral",
    "navMatching": "Pagtutugma",
    "logOut": "Mag-log out",
    "enterTitle": "Ipasok ang pagtutugma",
    "email": "Email",
    "password": "Password",
    "logIn": "Mag-log in",
    "emailPlaceholder": "ikaw@halimbawa.com",
    "navOnboarding": "Pagsisimula",
    "goOnboarding": "Pumunta sa onboarding →",
    "guestWoman": "Panauhin bilang babae",
    "passwordPlaceholder": "Ang iyong password",
    "guestMan": "Panauhin bilang tao",
    "man": "lalaki",
    "woman": "babae",
    "like": "parang",
    "likes": "gusto",
    "enterText": "Mag-log in gamit ang parehong email mula sa onboarding. Ginagamit ng application, pool, likes, at tugma ang iyong stable na user id.",
    "guestOr": "O subukan ang isang guest session (stable id bawat browser · demo lang)",
    "guestSession": "Sesyon ng bisita · demo pool",
    "tabToday": "Pagpili",
    "valuesScore": "Mga halaga {score}",
    "emptyMatches": "Wala pang mutual interest. Panatilihin ang pag-unawa sa mga mungkahi ngayong araw.",
    "yourMatches": "Iyong mga laban",
    "chatOpen": "· Bukas ang chat",
    "tabMatches": "Mga tugma ({count})",
    "matchesSub": "Patuloy na interes sa isa't isa · {count} palabas {likesWord}",
    "noProfileYet": "Wala pang profile",
    "matchingPaused": "Naka-pause ang pagtutugma",
    "noOneYet": "Wala pang magpapakita",
    "cityValues": "{city} · Mga Halaga {score}",
    "personLine": "{name}, {age}",
    "tapToChat": "· I-tap para makipag-chat",
    "todaysSetDone": "Iyon ang pagpili ngayong linggo",
    "noProfileText": "Tapusin ang onboarding, o i-tap ang Onboarding sa itaas, pagkatapos ay Magsimula. Nasa enter screen ang pagtutugma ng bisita kung gusto mo lang tumingin.",
    "backOnboarding": "Bumalik sa onboarding",
    "resetDeck": "I-reset ang deck",
    "demoPool": "demo",
    "likesMayNotStick": "Maaaring hindi dumikit ang mga gusto.",
    "poolMeta": "Pool: {pool} · Mga Tugma: {matches} · Nagustuhan: {liked}",
    "pass": "Laktawan",
    "livePool": "{source} ({count})",
    "emptyDone": "Napagdaanan mo ang mga mungkahi ngayong araw. Bumalik bukas, o i-reset ang deck upang tumingin muli.",
    "emptyNeverHad": "Walang tao sa listahan ngayon. Kung katatapos mo lang mag-onboard, maaaring walang laman pa rin ang live pool — subukan ang session ng bisita para makita ang mga taong demo, o bumalik pagkatapos maaprubahan ang higit pang mga miyembro.",
    "feedEyebrowLive": "Lingguhang pagpili · Pool ({source}, {count})",
    "interested": "Interesado",
    "likeHeart": "♥ Like",
    "heartsNoneLeft": "Wala nang puso ngayong linggo. Babalik sa Lunes.",
    "commentLead": "Sabihin ang isang bagay kay {name}. Sampung salita.",
    "commentPlaceholder": "Sampung salita, hindi higit pa",
    "commentCount": "{count} / {max}",
    "commentSend": "Ipadala ang puso kasama nito",
    "heartOnly": "Puso lang",
    "commentTooLong": "Lagpas sa {max} salita iyan. Naipadala ang puso; hindi ang mensahe.",
    "commentAnchors": {
      "about": "Tungkol sa akin",
      "lookingFor": "Hinahanap",
      "hobbies": "Mga interes",
      "photo": "Larawan"
    },
    "inboundTitle": "Nag-like sa iyo",
    "likeBack": "I-like pabalik",
    "left": "{count} ang natitira",
    "feedTitle": "Maunawaan nang may pag-iingat",
    "celebrationTitle": "Nagtugma kayo",
    "celebrationEyebrow": "Kapwa interes",
    "feedEyebrowDemo": "Lingguhang pagpili · Demo pool",
    "swipeHint": "Mag-swipe o gamitin ang mga pindutan. Ang isang laban ay bubukas lamang kapag ang interes ay magkapareho at nanatili.",
    "valuesScoreLabel": "Marka ng mga halaga",
    "affinity": "Pagkakatugma",
    "openChat": "Buksan ang chat",
    "cardSeeking": "naghahanap",
    "keepDiscerning": "Panatilihin ang pag-unawa",
    "cardHobbies": "Mga libangan",
    "celebrationNote": "Naka-unlock ang chat para sa laban na ito. Panatilihin itong magalang — makipagtipan sa kaginhawahan.",
    "celebrationText": "Parehong nagpakita ng interes sina {self} at {other}. Pag-align ng mga halaga: {score}.",
    "stampPass": "Laktawan",
    "explainLegacyClose": "Magkadikit ang iyong mga marka ng halaga ({score} ng 100).",
    "characterAxisFoot": "Kasama sa axis ng character ang apat na haligi",
    "youThem": "Ikaw {self} · Sila {other}",
    "scoreSolid": "Solid na pagkakahanay",
    "scoreStrong": "Malakas na pagkakahanay",
    "stampInterest": "interes",
    "scoreDifferent": "Iba't ibang ritmo",
    "scoreModerate": "Katamtamang pagkakahanay",
    "explainCharacter": "Paano mo tinatrato ang mga tao sa mga linya ng tahanan — kapayapaan, asal, at pangangalaga.",
    "explainFallback": "May posibleng tugma sa mga sagot na pareho ninyong pinunan.",
    "explainFaith": "Malapit na ang tindi ng iyong pananampalataya — sineseryoso mo ang pagsunod kay Jesus.",
    "explainLegacyFuller": "Lumilitaw ang isang mas kumpletong \"bakit\" pagkatapos ninyong dalawa matapos ang magkatugmang mga tanong.",
    "explainHome": "May interes ka sa lupa, pagtatanim ng pagkain, o sa sariling tahanan.",
    "explainPurpose": "Na-rate mo ang iyong sariling katapatan sa parehong paraan, na isang tanda ng ibinahaging kaseryosohan.",
    "explainAncestry": "Pareho kayong mas gusto ang magkatulad na background ng pamilya. Iyon ay isang kagustuhan, hindi isang filter — walang nakatago para dito.",
    "affinityAxes": {
      "ancestry": "Kaugnayan sa kultura at background",
      "home": "Tahanan at pagsasarili",
      "character": "Karakter at pag-uugali",
      "temperament": "Tama ang ugali",
      "faith": "Tindi ng pananampalataya",
      "purpose": "Pag-align ng layunin sa buhay"
    },
    "explainOverall": "Pangkalahatang affinity {score} ng 100.",
    "explainTemperament": "Ang iyong mga interes at ugali ay magkakapatong.",
    "scaleAxes": {
      "loyalty": "Katapatan",
      "commitment": "Pangako",
      "honesty": "Katapatan",
      "passion": "Simbuyo ng damdamin"
    },
    "weeklyTitle": "Ang iyong 4 ngayong linggo",
    "weeklyTitleCount": "Ang iyong {count} ngayong linggo",
    "weeklyCountdown": "Susunod na pagpili sa {days} araw",
    "weeklyCountdownOne": "Susunod na pagpili sa 1 araw",
    "weeklyCountdownSoon": "Susunod na pagpili malapit na",
    "shortWeekCopy": "Ngayong linggo may {count}. Hindi kami kailanman magmumungkahi ng taong hindi angkop.",
    "shortWeekTwo": "Ngayong linggo may dalawa. Hindi kami kailanman magmumungkahi ng taong hindi angkop.",
    "weekDone": "Iyan ang pagpili ngayong linggo",
    "weekDoneText": "Naunawa mo na ang lahat na matapat naming mairerekomenda. Bumalik kapag bumukas ang susunod na pagpili.",
    "waitingModeration": "Naghihintay ang iyong profile ng pag-apruba ng moderation bago bumukas ang pagpili.",
    "completeProfileFirst": "Kumpletuhin muna ang iyong profile at isumite ito.",
    "moderationDemoNote": "Ipinapakita namin ang mga demo na tao para masubukan mo ang pagtutugma.",
    "navSelection": "Pagpili",
    "navMessages": "Mensahe",
    "navProfile": "Profile",
    "packTitle": "Ang apat mo",
    "packSkip": "I-tap para magpatuloy",
    "newSelection": "Bagong pagpili",
    "backToFour": "← Bumalik sa apat mo",
    "whoLikedTitle": "Sino ang nag-like sa iyo",
    "whoLikedEmpty": "Wala pang bagong nag-like sa iyo.",
    "whoLikedLocked": "Mag-subscribe para makita ang mga pangalan sa lingguhang pagpili — ang mga papasok na puso ay nasa Mensahe pa rin."
  },
  "chat": {
    "valuesTrial": "Mga Halaga {score} · Pagsubok",
    "valuesSubscriber": "Mga Halaga {score} · Subscriber",
    "brandTag": "Usapan",
    "unavailableTitle": "Hindi available ang chat",
    "backMatches": "← Mga tugma",
    "backToMatches": "Bumalik sa mga laban",
    "ariaMessage": "Mensahe",
    "unavailableText": "Ang laban na ito ay nawawala o hindi kabilang sa iyong session.",
    "placeholder": "Mensahe {name}…",
    "empty": "Kamustahin nang may pag-iingat. Sa nakabahaging backend, nagsi-sync ang mga mensahe sa parehong mga telepono pagkatapos ng tugma.",
    "send": "Ipadala",
    "valuesKept": "Mga Halaga {score} · Panatilihin ang tugma"
  },
  "billing": {
    "signInFirst": "Mag-sign in muna.",
    "signInToMatch": "Mag-sign in para magamit ang pagtutugma.",
    "soon": "malapit na",
    "subscriberUntil": "Subscriber · hanggang {date}",
    "paywallCopy": "Pagkatapos ng iyong libreng pagsubok, panatilihin ang lahat na nakatugma mo na at patuloy na nakikipag-chat. Para makakita ng mga bagong tao, mag-subscribe.",
    "activeNote": "Aktibo ang subscription — maaari kang makakita muli ng mga bagong tao.",
    "freeTrial": "Libreng pagsubok · {days} araw (magtatapos sa {date})",
    "renewal": "pagpapanibago",
    "trialEnded": "Natapos ang pagsubok · manatiling bukas ang mga laban at chat",
    "subscribe": "Mag-subscribe · ${price}/buwan",
    "subscribeEarly": "Mag-subscribe nang maaga · ${price}/buwan",
    "playOnly": "Ang subscription ay Google Play Billing lamang (app install). Walang web checkout dito.",
    "playOnlyShort": "Billing sa Google Play lamang — walang web payment."
  },
  "auth": {
    "recoveryTitle": "I-save ang iyong code sa pagbawi",
    "savedContinue": "Nai-save ko na ito — magpatuloy",
    "welcomeBack": "Maligayang pagbabalik",
    "createAccount": "Lumikha ng iyong account",
    "intro": "Pangasiwaan at passphrase. Walang email o SMS na ipinadala. Nananatiling stable ang iyong id sa buong onboarding, pagsusuri, at pagtutugma.",
    "recoveryText": "Isulat ito ngayon. Ito ay ipinapakita nang isang beses. Kung mawala mo ang iyong passphrase, ang code na ito ang tanging paraan para i-reset ito sa closed test.",
    "tabRegister": "Magrehistro",
    "handle": "Panghawakan",
    "tabLogin": "Mag-log in",
    "handlePlaceholder": "you@example.com o isang maikling hawakan",
    "passphrase": "Lihim na parirala",
    "passphrasePlaceholder": "Hindi bababa sa 8 character",
    "submitRegister": "Gumawa ng account",
    "submitLogin": "Mag-log in",
    "backWelcome": "Bumalik sa pagtanggap"
  },
  "options": {
    "origin": {
      "european": "Europeo",
      "asian": "Asyano",
      "other": "Iba pa",
      "dutch": "Olandes",
      "german": "Aleman",
      "middleEastern": "Taga-Gitnang Silangan",
      "latino": "Latino / Hispanic",
      "mixed": "Halo-halo",
      "african": "Aprikano",
      "any": "Bukas — walang kagustuhan",
      "indigenous": "Katutubo"
    },
    "interest": {
      "prayer": "Panalangin",
      "hiking": "Pagha-hiking",
      "music": "Musika",
      "sports": "Palakasan",
      "missions": "Mga misyon",
      "crafts": "Mga likha",
      "farming": "Pagsasaka / paghahalaman",
      "reading": "Nagbabasa",
      "family": "Buhay ng pamilya",
      "worship": "Pagsamba",
      "outdoors": "Sa labas",
      "cooking": "Pagluluto"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Oo",
      "no": "Hindi"
    },
    "id": {
      "titleEmpty": "ID ng gobyerno",
      "titleReady": "Handa na ang ID",
      "hintEmpty": "Pasaporte o pambansang ID. Kumuha ng live na larawan, o pumili ng larawan/PDF. Lahat ng apat na sulok ay makikita.",
      "chooseFile": "Pumili ng file",
      "hintReady": "{fileName} · {bytes}{saved}",
      "replaceFile": "Palitan ang file",
      "pdfAria": "Pinili ang PDF na dokumento",
      "previewAlt": "Preview ng Government ID",
      "remove": "Alisin",
      "takePhoto": "Kumuha ng larawan",
      "retake": "Muling kunin",
      "savedSuffix": "· na-save",
      "signIn": "Mag-sign in bago mag-upload ng ID.",
      "badFile": "Hindi magamit ang file na ito.",
      "uploading": "Ina-upload…",
      "cameraTitle": "Kunin ang iyong ID",
      "uploadFailed": "Nabigo ang pag-upload. Subukan muli."
    },
    "video": {
      "titleEmpty": "Video ng kumpirmasyon",
      "hintReady": "{fileName} · {bytes}{saved}",
      "titleLive": "Live na camera",
      "titleReady": "Handa na ang video",
      "chooseFile": "Pumili ng file",
      "cancel": "Kanselahin",
      "hintEmpty": "Sabihin ang iyong pangalan at matapat kang sumali sa UN8. 5–15 segundo.",
      "replaceFile": "Palitan ang file",
      "remove": "Alisin",
      "record": "Itala",
      "stopSave": "Ihinto at i-save",
      "rec": "REC {seconds}s",
      "startRecording": "Simulan ang pagre-record",
      "cameraUpload": "Pag-upload ng camera",
      "recordAgain": "Record ulit",
      "uploadFailed": "Nabigo ang pag-upload. Subukan muli.",
      "unsupported": "Hindi available dito ang live recording. Gamitin ang pag-upload ng camera o pumili ng file.",
      "permissionDenied": "Tinanggihan ang pahintulot sa camera. Maaari ka pa ring mag-upload ng maikling video file.",
      "badVideo": "Hindi magamit ang video na ito.",
      "signIn": "Mag-sign in bago mag-upload ng video.",
      "saveFailed": "Hindi ma-save ang recording."
    },
    "photos": {
      "photoAlt": "Larawan {n}",
      "minimumMet": "Minimum na nakilala",
      "listAria": "Mga larawan sa pag-verify",
      "camera": "Kamera",
      "takePhoto": "Kumuha ng larawan",
      "uploading": "Ina-upload…",
      "moreRequired": "{n} pa ang kailangan",
      "count": "{count} / {max} mga larawan",
      "cameraTitle": "Kumuha ng larawan ng iyong sarili",
      "addFailed": "Hindi makapagdagdag ng mga larawan.",
      "chooseFiles": "Pumili ng mga file",
      "removeAria": "Alisin ang larawan {n}",
      "signIn": "Mag-sign in bago mag-upload ng mga larawan.",
      "hint": "Ang pagkuha ng larawan ay nagbubukas ng live na camera. Pumili ng mga file ay para lamang sa mga gallery pick. Maaliwalas na mga kuha sa mukha — walang mga filter na nagtatago ng pagkakakilanlan. Max {max}.",
      "someFailed": "Nabigong ma-upload ang ilang larawan. Subukan muli ang mga nabigo."
    },
    "liveStill": {
      "titleDefault": "Kamera",
      "close": "Isara",
      "capture": "Kunin",
      "cancel": "Kanselahin",
      "saveFailed": "Hindi ma-save ang larawan.",
      "frameFailed": "Hindi makuha ang frame na ito.",
      "unavailable": "Hindi available ang camera sa browser na ito. Gamitin ang Piliin ang file sa halip.",
      "permissionDenied": "Tinanggihan o hindi available ang pahintulot sa camera. Gamitin ang Piliin ang file sa halip.",
      "hint": "Humawak ng matatag. Ang live na camera ay mananatiling bukas hanggang sa makuha mo."
    },
    "uploadStatus": {
      "savedLocally": "na-save nang lokal",
      "failed": "nabigo ang pag-upload",
      "uploading": "ina-upload…",
      "localFallbackNote": "{error} Naka-save ang file sa device na ito; subukang muli kapag nakataas na ang sign endpoint.",
      "uploaded": "na-upload",
      "stored": "nakaimbak",
      "awaitingUpload": "Naghihintay ng pag-upload"
    }
  },
  "language": {
    "label": "Wika",
    "choose": "Pumili ng wika"
  },
  "shell": {
    "goBackAria": "Bumalik ka",
    "back": "Bumalik"
  },
  "questionnaire": {
    "skipForNow": "Laktawan sa ngayon",
    "skipConsequence": "Ang mga profile na nasagot ay ipinapakita muna.",
    "confirm": "Magpatuloy",
    "progressLabel": "{current} ng {total}",
    "fewSentences": "Ilang pangungusap",
    "ancestryNote": "Ito ay isang kagustuhan lamang na nakakaapekto sa ranggo — hindi inililimot ang sinuman."
  }
} as Messages;
